module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductBox":{"button":"Detail","priceWithoutTax":"bez DPH"}},"de":{"ProductBox":{"button":"Einzelheiten","priceWithoutTax":"ohne MwSt."}},"sk":{"ProductBox":{"button":"Detail","priceWithoutTax":"bez DPH"}}}')
  delete Component.options._Ctor
}
